import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/covid-tracker",
    name: "CovidTracker",
    component: () =>
      import(
        /* webpackChunkName: "covid-tracking" */ "../views/CovidTracker.vue"
      )
  },
  {
    path: "/covid-tracker/:state",
    name: "CovidTrackerState",
    component: () =>
      import(
        /* webpackChunkName: "covid-tracking" */ "../views/CovidTrackerState.vue"
      )
  },
  {
    path: "/language-translator",
    name: "LanguageTranslator",
    component: () =>
      import(
        /* webpackChunkName: "covid-tracking" */ "../views/LanguageTranslator.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
